module.exports = __webpack_public_path__ + "static/media/article2_slide2.59d899b4.jpg";